<template>
    <div class="d-flex flex-column flex-md-row mb-3">
        <div class="border rounded p-3 text-center flex-fill mb-3 mb-md-0 mr-md-3">
            <h3 class="d-block fw-bold p-0">Total</h3>
            <h2>{{ total }}</h2>
        </div>
        <div class="border rounded p-3 text-center flex-fill mb-3 mb-md-0 mr-md-3">
            <h3 class="d-block fw-bold p-0">Ativos</h3>
            <h2>{{ active }}</h2>
        </div>
        <div class="border rounded p-3 text-center flex-fill">
            <h3 class="d-block fw-bold p-0">Inativos</h3>
            <h2>{{ inactive }}</h2>
        </div>
    </div>
  </template>
  <script>
  export default {
    props: {
      total: Number,
      active: Number,
      inactive: Number,
    },
  };
  </script>